/** Layout shell — Sidebar + Topbar + main scroll area. Mobile (<768): bottom nav.
 *  Při admin impersonaci (m-CRM náhled) zobrazuje banner přes celou šířku. */

import { Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { BottomNav } from "./bottom-nav";
import { ImpersonationBanner } from "./impersonation-banner";
import { useAuth } from "@/auth/auth-provider";

export function Layout() {
  const location = useLocation();
  const { impersonated } = useAuth();
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Map route má vlastní fullscreen behavior — main bez vertical scroll
  const isMap = location.pathname === "/map";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      {impersonated && <ImpersonationBanner />}
      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
        {!isMobile && <Sidebar />}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          {!isMobile && <Topbar />}
          <main
            className="scroll"
            style={{
              flex: 1,
              overflowY: isMap ? "hidden" : "auto",
              position: "relative",
              paddingBottom: isMobile ? 60 : 0,
            }}
          >
            <Outlet />
          </main>
          {isMobile && <BottomNav />}
        </div>
      </div>
    </div>
  );
}
